// extracted by mini-css-extract-plugin
module.exports = {"hide":"PaymentTypesField_hide__WIYa-","formItem":"PaymentTypesField_formItem__3nF34"};